export enum TimeOperationsPermissions {
    Default = 0,
    Time_CloseTime = 1,
    Time_CreateTime = 1 << 1,
    Time_DeleteTime = 1 << 2,
}